// extracted by mini-css-extract-plugin
module.exports = {"capacityInput":"reservedCapacity_capacityInput__KRy1_","periodCol":"reservedCapacity_periodCol__3VT-_","typeCol":"reservedCapacity_typeCol__RZ7GT"};